export enum ButtonType {
  DEFAULT = 'default',
  ICON = 'icon',
}
